import { render } from "./IslerView.vue?vue&type=template&id=de446b14"
import script from "./IslerView.vue?vue&type=script&lang=js"
export * from "./IslerView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__